import Vue from 'vue'

const data = {
  path: location.pathname,
  hash: location.hash,
  search: location.search,
  query: {}
}

export const url = Vue.prototype.$url = new Vue({
  data,
  watch: {
    path () {
      if (this.path !== location.pathname) {
        this.push()
      }
    },
    hash () {
      if (this.hash !== location.hash) {
        this.push()
      }
    },
    search () {
      this.refresh()

      if (this.search !== location.search) {
        this.replace()
      }
    },
    query: {
      deep: true,
      handler () {
        const keys = Object.keys(this.query).filter(key =>
          this.query[key] !== undefined
        )

        if (keys.length) {
          const query = new URLSearchParams()

          keys.forEach(key => {
            query.set(key, this.query[key])
          })

          this.search = `?${query}`
        } else {
          this.search = ''
        }
      }
    }
  },
  methods: {
    push () {
      const prev = `${location.pathname}${location.search}${location.hash}`
      const next = `${this.path}${this.search}${this.hash}`

      if (prev !== next) {
        history.pushState(
          {},
          '',
          next
        )
      }
    },

    replace () {
      const prev = `${location.pathname}${location.search}${location.hash}`
      const next = `${this.path}${this.search}${this.hash}`

      if (prev !== next) {
        history.replaceState(
          {},
          '',
          next
        )
      }
    },

    refresh () {
      const query = new URLSearchParams(this.search)

      for (const key of Object.keys(this.query)) {
        if (query[key] === undefined) {
          this.$delete(this.query, key)
        }
      }

      for (const [key, value] of query) {
        if (this.query[key] !== value) {
          this.$set(this.query, key, value)
        }
      }
    }
  },
  created () {
    this.refresh()

    window.addEventListener('hashchange', () => {
      this.hash = location.hash
    })

    window.addEventListener('popstate', () => {
      this.path = location.pathname
      this.search = location.search
    })
  }
})
